@if (ofertaText && !isOfertaAccepted) {
<div class="oferta">
    <div class="card card-body">
        <span [innerHTML]="ofertaText"></span>

        <div class="mt-6 float-right" style="text-align: right;">
            <p-button type="button" label="Отказываюсь" icon="pi pi-ban" styleClass="p-button-raised p-button-danger"
                routerLink="/">
            </p-button>

            <p-button type="button" label="Принимаю" icon="pi pi-check" class="acceptBtn"
                styleClass="p-button-raised p-button-success" (click)="acceptOferta()">
            </p-button>
        </div>
    </div>
</div>
} @else {
<div class="box">
    <p-card>
        <ng-template #header>
            @let header = editMode ? 'Регистрационные данные пользователя' : 'Регистрация пользователя';

            <p class="text-center text-shadow-sm text-lg w-full">
                <i class="pi pi-user-plus"></i>
                {{header}}
            </p>
        </ng-template>

        <form [formGroup]="registerForm" (ngSubmit)="submitForm()" autocomplete="off">

            <div class="w-full">

                <div class="field">
                    <label for="first_name">Имя</label>
                    <input type="text" pInputText formControlName="first_name" id="first_name">

                    @if(registerForm.get('first_name')?.errors && registerForm.get('first_name')?.touched){
                    <small class="error_message">
                        Укажите имя клиента (минимум 2 символа)
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="last_name">Фамилия</label>
                    <input type="text" pInputText formControlName="last_name" id="last_name">

                    @if(registerForm.get('last_name')?.errors && registerForm.get('last_name')?.touched){
                    <small class="error_message">
                        Укажите фамилию клиента (минимум 2 символа)
                    </small>
                    }

                </div>

                <div class="field">
                    <label for="login">Логин для входа</label>
                    <input type="text" pInputText formControlName="login" id="login">

                    @if(registerForm.get('login')?.errors && registerForm.get('login')?.touched){
                    <small class="error_message">
                        @if(registerForm.get('login')?.hasError('loginAlreadyExist')) {
                        Пользователь с таким логином уже зарегистрирован
                        } @else {
                        Укажите логин для входа (минимум 3 символа)
                        }
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="phone">Номер телефона</label>
                    <input pInputText placeholder="Номер телефона" formControlName="phone" id="phone">

                    @if(registerForm.get('phone')?.errors && registerForm.get('phone')?.touched) {
                    <small class="error_message">
                        Введите номер телефона в формате +XXX (XXX) XХХ-ХХХХ
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="client_code">Код пользователя</label>
                    <input type="text" pInputText formControlName="client_code" id="client_code">

                    @if(registerForm.get('client_code')?.errors && registerForm.get('client_code')?.touched) {
                    <small class="error_message">
                        @if(registerForm.get('client_code')?.hasError('userAlreadyExist')) {
                        Данный код уже используется. Обратитесь к представителю карго.
                        } @else {
                        Код пользователя должен быть более 3х символов
                        }
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="client_city">Город</label>
                    <input type="text" pInputText formControlName="client_city" id="client_city">

                    @if(registerForm.get('client_city')?.errors && registerForm.get('client_city')?.touched){
                    <small class="error_message">
                        Пожалуйста укажите город
                    </small>
                    }
                </div>

                <div class="field">
                    <label for="email">Email</label>
                    <input type="text" pInputText formControlName="email" id="email">

                    @if(registerForm.get('email')?.errors && registerForm.get('email')?.touched) {
                    <small class="error_message">
                        @if(registerForm.get('email')?.hasError('emailAlreadyExist')) {
                        Пользователь с таким email уже зарегистрирован
                        } @else {
                        Неправильный формат email адреса
                        }
                    </small>
                    }
                </div>

                <div class="field" *ngIf="!editMode">
                    <label for="passwd">Пароль:</label>
                    <p-password formControlName="passwd" [toggleMask]="true" id="passwd"></p-password>

                    @if(registerForm.get('passwd')?.errors && registerForm.get('passwd')?.touched) {
                    <small class="error_message">
                        Пароль не может быть меньше 6 символов
                    </small>
                    }
                </div>

                <div class="field" *ngIf="!editMode">
                    <label for="passwd">Пароль (повторно)</label>
                    <p-password formControlName="passwd2" [toggleMask]="true" id="passwd2"></p-password>

                    @if(registerForm.get('passwd2')?.errors && registerForm.get('passwd2')?.touched) {
                    <small class="error_message">
                        @if(registerForm.get('passwd2')?.hasError('passwd2Mismatch')) {
                        Пароли не совпадают!
                        } @else {
                        Пароль не может быть меньше 6 символов
                        }
                    </small>
                    }
                </div>

            </div>

            <div class="mt-6 float-right">
                <p-button type="submit" label="{{editMode ? 'Сохранить' : 'Регистрация'}}" icon="pi pi-check"
                    [style]="{width: 100}">
                </p-button>
            </div>
        </form>
    </p-card>
</div>
}